var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIntensiveCare = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  width: 54,
  height: 54,
  fill: "none",
  viewBox: "0 0 54 54"
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#EFF5FF",
  d: "M51.102 28.51a24 24 0 1 0-45.862 9.9h43.723a23.9 23.9 0 0 0 2.139-9.9"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M3.701 38.41h46.8M1 38.41h1.5M51.701 38.41h1.5"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M44.584 6.288h-2.986V3.302a1.49 1.49 0 0 0-1.493-1.492H37.72a1.49 1.49 0 0 0-1.493 1.492v2.986h-2.987a1.49 1.49 0 0 0-1.493 1.493v2.388a1.49 1.49 0 0 0 1.493 1.493h2.986v2.985a1.49 1.49 0 0 0 1.493 1.493h2.388a1.493 1.493 0 0 0 1.493-1.493v-2.985h2.986a1.49 1.49 0 0 0 1.493-1.493V7.78a1.49 1.49 0 0 0-1.494-1.493"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M44.584 6.288h-2.986V3.302a1.49 1.49 0 0 0-1.493-1.492H37.72a1.49 1.49 0 0 0-1.493 1.492v2.986h-2.987a1.49 1.49 0 0 0-1.493 1.493v2.388a1.49 1.49 0 0 0 1.493 1.493h2.986v2.985a1.49 1.49 0 0 0 1.493 1.493h2.388a1.493 1.493 0 0 0 1.493-1.493v-2.985h2.986a1.49 1.49 0 0 0 1.493-1.493V7.78a1.49 1.49 0 0 0-1.494-1.493"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  d: "m28.362 23.389-7.105-7.103a1.506 1.506 0 1 0-2.129 2.13l7.969 7.968v.015h20.325a1.506 1.506 0 0 0 0-3.01z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "m28.362 23.389-7.105-7.103a1.506 1.506 0 1 0-2.129 2.13l7.969 7.968v.015h20.325a1.506 1.506 0 0 0 0-3.01z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "m22.356 17.392 1.596-1.597 5.977 5.976-1.597 1.597z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M44.736 32.701H24.744a.634.634 0 1 1 0-1.26h19.992a.634.634 0 1 1 0 1.26"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M23.398 28.292h1.89v7.56h-1.89zM44.19 28.292h1.89v7.56h-1.89z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M23.398 28.292h1.89v7.56h-1.89zM44.19 28.292h1.89v7.56h-1.89z"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M20.248 26.087h28.98v2.52h-28.98z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M42.928 22.608h-15.12a2.84 2.84 0 0 0-2.835 2.835v3.15a.944.944 0 0 0 .945.944h18.9a.945.945 0 0 0 .945-.945v-3.15a2.84 2.84 0 0 0-2.835-2.834m-6.615 1.889h3.15v3.15h-3.15zm-1.89 3.15h-3.15v-3.15h3.15zm-7.56-2.205a.946.946 0 0 1 .945-.945h1.575v3.15h-2.52zm17.01 2.205h-2.52v-3.15h1.575a.946.946 0 0 1 .945.945z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M42.928 22.608h-15.12a2.84 2.84 0 0 0-2.835 2.835v3.15a.944.944 0 0 0 .945.944h18.9a.945.945 0 0 0 .945-.945v-3.15a2.84 2.84 0 0 0-2.835-2.834m-6.615 1.889h3.15v3.15h-3.15zm-1.89 3.15h-3.15v-3.15h3.15zm-7.56-2.205a.946.946 0 0 1 .945-.945h1.575v3.15h-2.52zm17.01 2.205h-2.52v-3.15h1.575a.946.946 0 0 1 .945.945z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  d: "M22.137 36.797a2.205 2.205 0 1 0 4.41 0 2.205 2.205 0 0 0-4.41 0"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M23.398 36.797a.945.945 0 1 0 1.89 0 .945.945 0 0 0-1.89 0"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M22.137 36.797a2.205 2.205 0 1 0 4.41 0 2.205 2.205 0 0 0-4.41 0"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  d: "M42.926 36.797a2.205 2.205 0 1 0 4.41 0 2.205 2.205 0 0 0-4.41 0"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M44.19 36.797a.945.945 0 1 0 1.89 0 .945.945 0 0 0-1.89 0"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M42.926 36.797a2.205 2.205 0 1 0 4.41 0 2.205 2.205 0 0 0-4.41 0"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  d: "M3.465 51.758c0 .369.977.722 2.717.983s4.1.408 6.56.408 4.821-.147 6.561-.407c1.74-.261 2.717-.615 2.717-.984 0-.37-.977-.723-2.717-.984s-4.1-.408-6.56-.408-4.82.147-6.56.408c-1.74.26-2.718.615-2.718.984"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M15.803 37.103a1.958 1.958 0 0 0 3.915 0v-1.958h-3.915z"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  d: "M19.72 25.076a8.39 8.39 0 0 0-16.78 0v1.119l3.892 8.897H19.72z"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.81,
  d: "M13.603 16.996a.6.6 0 0 1-.437-.589l.053-2.73-3.476-.065-.054 2.765a.6.6 0 0 1-.455.57 7 7 0 0 0-1.09.365l5.004 2.778 1.68-2.64a8 8 0 0 0-1.225-.454"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M7.974 50.249h7.831l1.119-15.103h2.797v-.053H6.832l.023.053z"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10.75 21.292v19.8a1.2 1.2 0 0 1-1.2 1.2h-5.4a1.2 1.2 0 0 1-1.2-1.2v-16.23a8.39 8.39 0 0 1 5.495-7.668 4.79 4.79 0 0 1 2.304 4.098"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M10.75 21.292v19.8a1.2 1.2 0 0 1-1.2 1.2h-5.4a1.2 1.2 0 0 1-1.2-1.2v-16.23a8.39 8.39 0 0 1 5.495-7.668 4.79 4.79 0 0 1 2.304 4.098"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M10.748 21.292v10.902l-3-7.002 1.5-3H7.554a.6.6 0 0 1-.6-.593l-.046-3.649q.105-.072.216-.132.632-.371 1.32-.624a4.79 4.79 0 0 1 2.304 4.098"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M19.719 25.078v10.068h-1.77v5.946a1.2 1.2 0 0 1-1.2 1.2h-.3v-21a4.8 4.8 0 0 0-2.4-4.158 8.41 8.41 0 0 1 5.67 7.944"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M19.719 25.078v10.068h-1.77v5.946a1.2 1.2 0 0 1-1.2 1.2h-.3v-21a4.8 4.8 0 0 0-2.4-4.158 8.41 8.41 0 0 1 5.67 7.944"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "m16.447 30.592 2.1-5.7-.9-2.7h1.5"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  fill: "#8B8B8B",
  d: "M11.889 38.195v12.612Z"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M11.889 38.195v12.612"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M11.889 48.626h2.741c2.74 0 3.426 2.741 3.426 2.741H11.89z"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M7.973 48.626h2.741c2.74 0 3.426 2.741 3.426 2.741H7.973z"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M17.18 36.778a.93.93 0 0 1-1.02.822l-5.924-.641a.93.93 0 0 1-.823-1.02l1.063-9.81a.93.93 0 0 1 1.02-.823l.742.08a2.233 2.233 0 1 1 4.44.48l.743.08a.927.927 0 0 1 .822 1.02z"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M16.365 34.027a1.956 1.956 0 0 0-1.958-1.958H11.33v3.916h3.077a1.96 1.96 0 0 0 1.958-1.958"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M6.856 25.915v1.294a6.4 6.4 0 0 0 1.233 3.407 3.96 3.96 0 0 0 3.24 1.45h1.119a3.94 3.94 0 0 0 0 3.916H11.33a7.66 7.66 0 0 1-5.994-2.546 10.33 10.33 0 0 1-2.396-6.15v-1.37"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M6.856 25.915v1.294a6.4 6.4 0 0 0 1.233 3.407 3.96 3.96 0 0 0 3.24 1.45h1.119a3.94 3.94 0 0 0 0 3.916H11.33a7.66 7.66 0 0 1-5.994-2.546 10.33 10.33 0 0 1-2.396-6.15v-1.37"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  fill: "#1E255D",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M2.941 25.078q-.001-.108.006-.216v1.344l-.006-.012z"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "m10.75 21.016.435.42a.6.6 0 0 0 .88-.045l1.085-1.303 1.252 1.073a.6.6 0 0 0 .986-.381l.266-2.137M5.049 38.092l2.7-1.2"
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M11.89 2.679a5.585 5.585 0 0 0-5.586 5.585v1.117c-1.595 0-1.485 2.793.28 2.793h.004A5.57 5.57 0 0 0 17.476 10.5V8.264A5.584 5.584 0 0 0 11.89 2.68"
})), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  fill: "#1E255D",
  d: "M10.213 9.52a.698.698 0 1 0 1.397 0 .698.698 0 0 0-1.397 0M15.8 9.52a.698.698 0 1 1-1.397 0 .698.698 0 0 1 1.396 0"
})), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  d: "M10.215 11.755a.558.558 0 1 1-1.116 0 .558.558 0 0 1 1.116 0"
})), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M11.611 12.679a2.095 2.095 0 0 0 2.465.23q.173-.102.328-.23"
})), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M7.973 9.94a2.234 2.234 0 0 1 2.234-2.235h7.28a.926.926 0 0 0 .914-1.109A6.957 6.957 0 0 0 4.62 7.985v8.188a.94.94 0 0 0 1.165.904c1.397-.333 2.016-1.316 2.186-2.669z"
})), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M7.973 9.94a2.234 2.234 0 0 1 2.234-2.235h7.28a.926.926 0 0 0 .914-1.109A6.957 6.957 0 0 0 4.62 7.985v8.188a.94.94 0 0 0 1.165.904c1.397-.333 2.016-1.316 2.186-2.669z"
})), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M11.88 7.705V5.47M9.643 7.782l.005-2.311M14.115 7.705V5.47M16.352 7.705V5.47M13.148 20.093v3.6"
})));
export { SvgIntensiveCare as ReactComponent };